export default __webpack_public_path__ + "static/media/HOMEPAGE.6d9ef014.jpg";